// extracted by mini-css-extract-plugin
export default {"icon":"PasswordShowHide_icon__dBj-m"};